<template>
  <section v-if="founderType==='BLOCKED'">
    <p>Доступ в этот раздел ограничен</p>
  </section>
  <section v-else>
    <div class="d-flex flex-row justify-space-between align-center mb-3">
      <h1 class="section-header__title">
        Согласование проекта КЦП Субъектов Российской Федерации
      </h1>
      <div class="d-flex flex-row align-start">
        <v-icon
            size="20"
            color="info"
            class="mt-2 mr-2"
        >
          mdi-magnify
        </v-icon>
        <v-text-field
            v-model="search"
            color="info"
            outlined
            label="Начните набирать наименование региона"
            class="search-field"
            dense
            style="min-width: 500px"
        />
      </div>
    </div>
    <wrapper-preview-category>
      <grid-table
          :headers="headers.massive"
          :headers-for-rows="headers.massive"
          :num-cols="headers.countCells"
          :loading-data="loading"
          :data-rows="showingData"
          type-table="grid"
      >
        <template #downloadExcel="{ row }">
          <div class="d-flex flex-column align-end">
            <v-btn
                class="white__v-btn"
                @click="downloadPrint('ExcelStage2', downloadingPrintExcel,`Экспорт данных (${row.name}).xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',`?regionId=${row?.id}`)"
            >
              Выгрузить
            </v-btn>
          </div>
        </template>
        <template #approvalFile="{ row }">
          <div class="d-flex flex-column align-end">
            <v-btn
                v-if="row.scanRegion"
                class="white__v-btn"
                @click="downloadFile(row.scanRegion)"
            >
              Скачать
            </v-btn>
            <span v-else>Нет загруженного файла</span>
          </div>
        </template>
        <template #uploadScan="{ row }">
          <div class="d-flex flex-column align-end">
            <v-btn
                class="white__v-btn" @click="openScanDialog(row)"
            >
              Загрузить и подписать
            </v-btn>
          </div>
        </template>
        <template #status="{ row }">
          <v-icon v-if="row.scanAcception" size="24" color="primary">mdi-check</v-icon>
          <v-icon v-else size="24" color="error">mdi-close</v-icon>
        </template>
      </grid-table>
      <v-dialog v-model="scanDialog" max-width="800">
        <v-card>
          <v-form>
            <v-card-title>
              <h2>Загрузка и подписание сопроводительного письма</h2>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <file-container
                      :num-stage="3" :current-stage="3" :cols="9"
                      :files-config="scanConfig(rowForFile)" :regionID="rowForFile.id"
                      :key="fileKey"
                      :staticFiles="[rowForFile.scanRegion, rowForFile.scanAcception, rowForFile.scanAcceptionSign]"
                      @upload-file="initFiles"
                  />
                  <template v-if="rowForFile.scanAcception && !rowForFile.scanAcceptionSign">
                    <div v-if="isValidSystemSetup">
                      <v-autocomplete
                          v-model="chosenCertificate"
                          :items="certificatesList"
                          label="Выберите сертификат, которым будет произведена подпись данных"
                          no-data-text="Нет доступных сертификатов"
                          dense
                          class="mt-2"
                          clearable
                          outlined
                      ></v-autocomplete>
                      <v-btn class="blue__v-btn" :disabled="!chosenCertificate" :loading="signingFile"
                             @click="signUploadedFile(rowForFile.scanAcception.id, `${founderType}_SIGN`, `${rowForFile.id}`)">
                        Подписать
                      </v-btn>
                    </div>
                    <div v-else>
            <span class="red--text">Не установлен CryptoPro CAdES или плагин работает не правильно.
              Проверить проблемы можно на странице <a
                  href="https://cryptopro.ru/sites/default/files/products/cades/demopage/cades_bes_sample.html">Проверка создания электронной подписи CAdES-BES</a></span>
                    </div>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
    </wrapper-preview-category>
  </section>
</template>

<script>
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import approvalRegions from "@/helpers/tableConfigs/approvalRegionsAlt";
import GridTable from "@/components/GridTable/GridTable";
import {mapActions, mapGetters} from "vuex";
import FileContainer from "@/containers/FileContainer";
import {setFileFunctions} from "@/mixins/fileFucntions";
import {setCryptoProFunctions} from "@/mixins/cryptoProFunctions";
import RegionController from "@/controllers/OKCP/RegionController";

export default {
  name: "ApprovalRegions",
  components: {GridTable, WrapperPreviewCategory, /*ScanCard,*/ FileContainer},
  mixins: [setFileFunctions, setCryptoProFunctions],
  data() {
    return {
      search: '',
      headers: approvalRegions,
      loading: false,
      downloadingFileToServer: {regionId: 0, value: false, fileType: null},
      serverData: [],
      regionsWithFiles: [],
      downloadingFile: false,
      excelDialog: false,
      rowForFile: {},
      fileKey: 0,
      // fileKey2: 0,
      scanDialog: false,
    }
  },
  computed: {
    ...mapGetters('spr', {
      getRegions: 'getRegions',
      getRegionsStatus: 'getRegionsStatus'
    }),
    ...mapGetters('keycloak', {isAdmin: 'isAdmin', isCO: 'isCO', userId: 'userId', getFakeUser: 'getFakeUser'}),
    founderType() {
      if (this.userId === 18 || this.userId === 117 || this.getFakeUser?.id === 18 || this.getFakeUser?.id === 117) {
        if (this.userId === 18 || this.getFakeUser?.id === 18) {
          return "AGREEMENT_FILE_STAGE_TWO_ECONOM"
        } else {
          return "AGREEMENT_FILE_STAGE_TWO_VOSTOK"
        }
      } else {
        return "BLOCKED"
      }
    },
    showingData() {
      return this.regionsWithFiles.filter(el => !this.search || el.name.toLowerCase().search(this.search.toLowerCase()) !== -1)
    },
  },
  created() {
    this.getServerData();
    this.checkSystem()
  },
  methods: {
    ...mapActions('spr', {getRegionsFromServer: 'getRegionsFromServer'}),
    scanConfig(row) {
      return [{
        name: 'Сопроводительное письмо',
        types: ['application/pdf'],
        typesForChose: ['application/pdf'],
        id: null,
        fileType: this.founderType,
        canUpload: !row.scanAcceptionSign
      }, {
        name: 'Подпись сопроводительного письма',
        types: ['sig'],
        typesForChose: ['sig'],
        id: null,
        fileType: `${this.founderType}_SIGN`,
        canUpload: false
      }]
    },
    initFiles(data) {
      let editReg = this.regionsWithFiles.find(el => el.id === data.userId)
      if (this.founderType === data.fileType) {
        console.log("scanAcception")
        editReg.scanAcception = data;
      }
      if (this.founderType+"_SIGN" === data.fileType) {
        console.log("scanAcceptionSign")
        editReg.scanAcceptionSign = data;
      }
      this.scanDialog = false
    },

    async getServerData() {
      await RegionController.getRegionsWithScanFilesAltData(this.founderType).then(data => {
        if (this.userId === 18 || this.getFakeUser?.id === 18)
          this.regionsWithFiles = data.filter(el => [16, 20, 24, 29, 69, 71, 85].includes(el.id))
        else
          this.regionsWithFiles = data.filter(el => [5, 6, 11, 17, 18, 28, 30, 33, 36, 42, 47, 56, 65, 66, 81, 89, 90, 93].includes(el.id))
      })
    },

    openScanDialog(row) {
      this.scanDialog = true;
      this.rowForFile = row;
      this.fileKey++;
    },
  },
}
</script>

<style scoped>

</style>